// Copyright (c) 2026 Otyka LLC. All rights reserved.

import React from 'react';
import AdminApp from '../admin/AdminApp';

export default function BrandingAdmin() {
  return <AdminApp />;
}
